import { lazy } from 'react';

const ProductSalesManufacturerConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/manufacturer/consult/product-sales',
			component: lazy(() => import('./ProductSalesContainer'))
		}
	]
};

export default ProductSalesManufacturerConfig;
